import * as tslib_1 from "tslib";
import { CustomerActionTypes, UserRole } from './types';
var initialState = {
    user: null,
    bookmarks: null,
    bookmarkLists: null,
    products: null,
    type: CustomerActionTypes.INITIAL_STATE
};
function hash(data) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var encoder, buffer, _a, _b, _c;
        return tslib_1.__generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    encoder = new TextEncoder();
                    _b = (_a = Array).from;
                    _c = Uint8Array.bind;
                    return [4 /*yield*/, window.crypto.subtle.digest('SHA-256', encoder.encode(data))];
                case 1:
                    buffer = _b.apply(_a, [new (_c.apply(Uint8Array, [void 0, _d.sent()]))()]);
                    return [2 /*return*/, buffer
                            .map(function (b) { return b.toString(16).padStart(2, '0'); })
                            .join('')];
            }
        });
    });
}
function setCookie(name, value, days) {
    if (days === void 0) { days = 0; }
    var d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    var expiry = days !== 0 ? ' expires=' + d.toUTCString() + ';' : '';
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + ";" + expiry + " path=/; domain=" + ('.ltur.' + location.host.split('.').pop());
}
function updateUserSessionStorage(user) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!user || !user.authorities || !user.authorities.includes(UserRole.ROLE_USER)) {
                        return [2 /*return*/];
                    }
                    setCookie('session_login_user_id', user.userId);
                    _a = setCookie;
                    _b = ['login_hash'];
                    return [4 /*yield*/, hash(user.userId)];
                case 1:
                    _a.apply(void 0, _b.concat([_c.sent(), 365]));
                    return [2 /*return*/];
            }
        });
    });
}
var reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case CustomerActionTypes.CUSTOMER_LOGIN_ANONYMOUS:
        case CustomerActionTypes.CUSTOMER_LOGIN:
        case CustomerActionTypes.CUSTOMER_BOOKMARK_ACTION:
            var nextState = tslib_1.__assign({}, state, action);
            //updateUserSessionStorage(nextState.user);
            return nextState;
        default: {
            return state;
        }
    }
};
export { reducer as customerReducer };
